"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCertifierRpc = exports.HasSessionResponse = exports.HasSessionRequest = void 0;
// @generated by protobuf-ts 2.9.6 with parameter server_generic,generate_dependencies,long_type_number
// @generated from protobuf file "packages/autocertifier-client/protos/AutoCertifier.proto" (syntax proto3)
// tslint:disable
const runtime_rpc_1 = require("@protobuf-ts/runtime-rpc");
const runtime_1 = require("@protobuf-ts/runtime");
// @generated message type with reflection information, may provide speed optimized methods
class HasSessionRequest$Type extends runtime_1.MessageType {
    constructor() {
        super("HasSessionRequest", [
            { no: 1, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message HasSessionRequest
 */
exports.HasSessionRequest = new HasSessionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HasSessionResponse$Type extends runtime_1.MessageType {
    constructor() {
        super("HasSessionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message HasSessionResponse
 */
exports.HasSessionResponse = new HasSessionResponse$Type();
/**
 * @generated ServiceType for protobuf service AutoCertifierRpc
 */
exports.AutoCertifierRpc = new runtime_rpc_1.ServiceType("AutoCertifierRpc", [
    { name: "hasSession", options: {}, I: exports.HasSessionRequest, O: exports.HasSessionResponse }
]);
//# sourceMappingURL=AutoCertifier.js.map